import React from "react";
import "../styles/About.css";
import { Twitter, GitHub, LinkedIn } from "@mui/icons-material";
import frontend from "../images/frontend.jpg";
import blockchain from "../images/blockchain.jpg";

const About = () => {
  return (
    <div className="about">
      <h2>About Me</h2>
      <p>
        I am a dedicated Front End Developer with a passion for crafting
        innovative solutions in the web space. My expertise lies in creating
        seamless and user-centered experiences that bridge technology and
        design. Alongside my programming journey, I am a blockchain enthusiast,
        intrigued by its potential to reshape industries and drive
        decentralization. Eager to contribute my skills to meaningful projects
        and explore the evolving landscapes of both web development and
        blockchain technology.
      </p>
      <h4>Check Me Out</h4>
      <div className="about_social">
        <a href="https://www.linkedin.com/in/keyur-g-kulkarni-273072237">
          {" "}
          <LinkedIn />
        </a>
        <a href="https://github.com/KeyurGK">
          <GitHub />
        </a>

        <a href="https://twitter.com/keyurGK">
          {" "}
          <Twitter />
        </a>
      </div>
      <div className="about_toolkit">
        <div className="about_toolkit-frontend">
          <h3>Front End</h3>
          <img src={frontend} alt="frontend logo" />
          <ul>
            <li>JavaScript</li>
            <li>React</li>
            <li>Tailwind CSS</li>
            <li>Firebase</li>
            <li>Next.js</li>
          </ul>
        </div>
        <div className="about_toolkit-web3">
          <h3>Web3</h3>
          <img src={blockchain} alt="blockchain logo" />
          <ul>
            <li>Solidity</li>
            <li>Hardhat</li>
            <li>Ether.js</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default About;
